import React from 'react';

interface IProps {
  fillColor?: string;
  style?: any;
}

export const LeftArrowIcon:React.FC<IProps> = (props) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#a)">
        <path d="M16.173 25.126c.007.305.127.595.336.816l7.375 7.683a1.233 1.233 0 0 0 1.776-1.71l-6.558-6.827 6.558-6.828a1.232 1.232 0 0 0-1.776-1.709l-7.375 7.682a1.23 1.23 0 0 0-.336.893z" fill="#204078"/>
    </g>
    <defs>
        <filter id="a" x="-11" y="-9" width="76" height="76" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dx="4" dy="4"/>
            <feGaussianBlur stdDeviation="10"/>
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2094_35255"/>
            <feBlend in="SourceGraphic" in2="effect1_dropShadow_2094_35255" result="shape"/>
        </filter>
    </defs>
</svg>

  )
}